var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tax-type-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "", enctype: "multipart/form-data" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitformTemplate($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.name")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-7" },
              [
                _c("base-input", {
                  ref: "name",
                  attrs: { type: "text" },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formTemplate.name.$touch()
                    },
                  },
                  model: {
                    value: _vm.formTemplate.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formTemplate, "name", $$v)
                    },
                    expression: "formTemplate.name",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formTemplate.name.$error
                  ? _c("div", [
                      !_vm.$v.formTemplate.name.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                _vm._s(_vm.$tc("validation.name_required"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formTemplate.name.minLength
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$tc(
                                      "validation.name_min_length",
                                      _vm.$v.formTemplate.name.$params.minLength
                                        .min,
                                      {
                                        count:
                                          _vm.$v.formTemplate.name.$params
                                            .minLength.min,
                                      }
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("user_guides.document")) + " "),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-7" }, [
              _vm.isEdit == false
                ? _c("input", {
                    ref: "file",
                    attrs: { type: "file" },
                    on: {
                      change: _vm.onFileChange,
                      input: function ($event) {
                        return _vm.$v.formTemplate.document.$touch()
                      },
                    },
                  })
                : _c("input", {
                    ref: "file",
                    attrs: { type: "file" },
                    on: { change: _vm.onFileChange },
                  }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "form-group__message text-danger" }, [
                _vm._v(_vm._s(_vm.$t("user_guides.documentSizelessthan20MB"))),
              ]),
              _vm._v(" "),
              _vm.isEdit == false && _vm.$v.formTemplate.document.$error
                ? _c("div", [
                    !_vm.$v.formTemplate.document.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeUserGuideModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.isSubmitDisabled,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      !_vm.isEdit
                        ? _vm.$t("general.save")
                        : _vm.$t("general.update")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }